import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const CartContext = createContext(null);
const STORAGE_KEY = "mm_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, quantity = 1) => {
    setItems((cur) => {
      const idx = cur.findIndex((it) => it.product_id === product.id);
      if (idx >= 0) {
        const copy = [...cur];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      return [
        ...cur,
        {
          product_id: product.id,
          name: product.name,
          slug: product.slug,
          price: product.price,
          image: (product.images || [])[0] || "",
          quantity,
        },
      ];
    });
    toast.success(`${product.name} sepete eklendi`);
  };

  const updateQty = (id, qty) =>
    setItems((cur) => cur.map((it) => (it.product_id === id ? { ...it, quantity: Math.max(1, qty) } : it)));

  const removeItem = (id) => setItems((cur) => cur.filter((it) => it.product_id !== id));

  const clear = () => setItems([]);

  const subtotal = useMemo(
    () => items.reduce((acc, it) => acc + it.price * it.quantity, 0),
    [items]
  );
  const count = useMemo(() => items.reduce((acc, it) => acc + it.quantity, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
